/*
 * Filters to convert datetime object to/from Django datetime str and JS Date
 * Django datetime string format: 2019-02-22T13:00:00+01:00
 */


// Create an ISO-typical string for timezone offset
const makeTimeZoneOffsetStr = function(date_obj) {
    return `+${ leadZero( -(date_obj.getTimezoneOffset() / 60) ) }:00`
}

// Convert Django datetime string to JS Date object
const dateDjango2js = function(django_datestr) {
    if (django_datestr) {
        const d = django_datestr.split(/[-:T]/),
              js_d = new Date(d[0], d[1] - 1, d[2], d[3], d[4])
        return js_d
    } else {
        return null
    }
}

// Convert JS Date object to Django datetime string
const dateJs2django = function(date_obj) {
    if (date_obj) {
        return `${ date_obj.getFullYear() }-${ leadZero(date_obj.getMonth() + 1)  }-${ leadZero(date_obj.getDate()) }T${ leadZero(date_obj.getHours()) }:${ leadZero(date_obj.getMinutes()) }:00${ makeTimeZoneOffsetStr(date_obj) }`
    } else {
        return null
    }
}

// Prettyprint Django Datetime for UI
const displayDjangoDate = function(date_str) {
    return displayJSDate( dateDjango2js(date_str) ) + ' ' + displayJSTime( dateDjango2js(date_str) )
}

// Prettyprint JS Date for UI
const displayJSDate = function(date_obj) {
    let datestr = ''
    datestr = date_obj.toLocaleDateString(['da-DK', 'en-US'], { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
    datestr.replace('den ', '')
    return datestr
}

// Prettyprint JS Time for UI
const displayJSTime = function(date_obj) {
    return `${ leadZero(date_obj.getHours()) }.${ leadZero(date_obj.getMinutes()) }`
}

// Create a set of datetimes spanning exactly 24 hours
const createDaySpan = function(date_obj) {
    let date1 = date_obj.getTime() + 86400000 // 24 hours' worth of milliseconds
    return {
        today: date_obj,
        tomorrow: new Date(date1)
    }
}


/*
 * Filters to display numbers with leading zeros.
 * Example: Display 3 as '03' in number of minutes
 */

const leadZero = function(number) {
    let n = parseInt(number)
    if (n < 10) {
        n = `0${ n }`
    }
    return n
}


/*
 * Filters to sort lists 
 */

const sortBookings = function(bookings) {
    let b_list = bookings
    // sort by starttime first, secondly by endtime, thirdly by resource name
    b_list.sort(function (a, b) {
        if (a.start > b.start) {
            return 1
        } else if (a.start < b.start) {
            return -1
        } else {
            if (a.end > b.end) {
                return 1
            } else if (a.end < b.end) {
                return -1
            } else {
                if (a.resource_name > b.resource_name) {
                    return 1
                } else if (a.resource_name < b.resource_name) {
                    return -1
                } else {
                    return 0
                } 
            }    
        }
    })
    return b_list
}


export {
    dateDjango2js,
    dateJs2django,
    displayDjangoDate,
    displayJSDate,
    displayJSTime,
    leadZero,
    makeTimeZoneOffsetStr,
    createDaySpan,
    sortBookings
}